export const PeriodicDefaultTime = 60000;

export interface ITimeTrackInfo {
  callback: () => void;
  trackTime?: number;
}

export interface ICallbackInfo {
  name: string;
  callback: () => void;
}